import React from 'react';
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogContentText, 
  DialogActions, 
  Typography, 
  Button, 
  Box, 
  IconButton, 
  CircularProgress
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { borderRadius, palette, spaces } from '../../assets/styles/themes/tokens';

interface SuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  dialogTitle: string;
  dialogContent: string;
  showCloseButton: boolean;
  showActionButton: boolean;
  isLoading: boolean;
  onSuccessModalConfirmButtonClick?: () => void;
  buttonLabel?: string;
}

const SuccessModal: React.FC<SuccessModalProps> = (props) => {
  const {
    isOpen,
    onClose,
    dialogTitle,
    showCloseButton,
    showActionButton,
    onSuccessModalConfirmButtonClick,
    dialogContent,
    buttonLabel,
    isLoading,
  } = props;
  return (
    <Dialog
      data-testid='upgrade-success-modal'
      open={isOpen}
      disableEscapeKeyDown
      sx={{
        borderRadius: borderRadius.md, 
        '& .MuiDialog-paper': {
          width: '100%',
        }
      }}
    >
      <DialogTitle
        component='div'  
        sx={{ 
          padding: spaces.lg, 
          display: 'flex',
          justifyContent: 'space-between'
        }} 
      >
        <Typography variant='h5' color={palette.text.primary}>{dialogTitle}</Typography>
        {showCloseButton && (
          <Box>
            <IconButton
              color='default'
              size='small'
              onClick={onClose}
              data-testid='close-button'
            >
              <CloseIcon />
            </IconButton>
          </Box>
        )}
      </DialogTitle>
      <DialogContent sx={{ padding: `0px ${spaces.lg} ${spaces.lg} ${spaces.lg}` }}>
        <DialogContentText sx={{ typography: 'body1', color: palette.text.secondary }}>
          {dialogContent}
        </DialogContentText>
      </DialogContent>
      {showActionButton && (
        <DialogActions sx={{ padding: spaces.lg }}>
          <Button
            sx={{ width: '100%' }} 
            onClick={onSuccessModalConfirmButtonClick}
            variant='contained'
            color='primary'
            size='large'
            disabled={isLoading}
          >
            {isLoading ? 
              <CircularProgress size={26} sx={{
                color: palette.common.white,
                '& .MuiCircularProgress-svg': {
                  height: 'auto',
                  width: 'auto',
                },
              }} /> : buttonLabel}
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
};

export default SuccessModal;

